export default __webpack_public_path__ + "static/media/14_long.53f00619.svg";